import React from 'react'
import { ModalWindow } from '../../GeneralComponents/ModalWindow/ModalWindow'
import { ButtonOutline } from '../../GeneralComponents/ButtonOutline/ButtonOutline'
import PropTypes from 'prop-types'
import classes from './index.module.css'

export default function SaveConfirmationModal({
  open,
  onClose,
  onConfirm,
  isLoading,
  changes,
}) {
  if (!open) return null

  return (
    <ModalWindow open={open} onClose={onClose} rounded={true} disableCloseIcon={true}>
      <div className={classes.modalContent}>
        <h2 className={classes.title}>Confirm Changes</h2>
        <p className={classes.subtitle}>Review your changes before saving:</p>

        <div className={classes.changesList}>
          {changes.feelsChanged && (
            <div className={classes.changeItem}>
              <span className={classes.changeLabel}>Feels</span>
              <span className={classes.changeValue}>
                Reordered / updated ({changes.feelsCount} feels)
              </span>
            </div>
          )}
        </div>

        <div className={classes.buttonGroup}>
          <ButtonOutline
            text="Cancel"
            color="red"
            size="small"
            onClick={onClose}
            disable={isLoading}
          />
          <ButtonOutline
            text={isLoading ? 'Saving...' : 'Confirm Save'}
            color="green"
            size="small"
            onClick={onConfirm}
            disable={isLoading}
          />
        </div>
      </div>
    </ModalWindow>
  )
}

SaveConfirmationModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  isLoading: PropTypes.bool,
  changes: PropTypes.shape({
    feelsChanged: PropTypes.bool,
    feelsCount: PropTypes.number,
  }),
}
